module.exports = __webpack_public_path__ + "img/bgc2.7b42bdcd.png";